<template>
  <SimpleDictView
    endpoint="ranks/"
    :title="$t('settings.titles.ranks')"
    :add-button="$t('settings.addButtons.rank')"
    :fields="fields"
  />
</template>

<script>
import SimpleDictView from './SimpleDictView.vue'
export default {
  name: 'RanksView',
  components: { SimpleDictView },
  computed: {
    fields() {
      return [
        { key: 'name', label: this.$t('settings.fields.name'), placeholder: this.$t('settings.placeholders.rankName') },
        { key: 'group', label: this.$t('settings.fields.group'), placeholder: this.$t('settings.placeholders.rankGroup') },
      ]
    },
  },
}
</script>
